export interface BrowserProgressBarSettings {
    minimum: number,
    transitionsSpeedMs: number; // Milliseconds for smooth transitions
    transitionsEasing: string; // Transitions easing
    trickleFillRate: number; // How much the progress increases with each trickle
    trickleFrequencyMs: number; // Frequency of trickles in milliseconds
}

export const DEFAULT_BROWSER_PROGRESS_BAR_SETTINGS: BrowserProgressBarSettings = {
    minimum: 0.08,
    transitionsSpeedMs: 300,
    transitionsEasing: 'ease',
    trickleFillRate: 0.02,
    trickleFrequencyMs: 500
}